const { borderVariables } = require('./border')
const { strokeIconVariables } = require('./strokeIcon')
const { backgroundVariables } = require('./background')
const { textVariables } = require('./text')
const { contentVariables } = require('./content')

module.exports = {
  backgroundVariables,
  borderVariables,
  strokeIconVariables,
  textVariables,
  contentVariables,
}
